import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import './GenreFilter.pcss';
import { GENRE } from '../../constants';
function extractGenres(games) {
    const genres = games.flatMap((item) => {
        const genreAttribute = item.attributes.find((attr) => attr.name.toLowerCase() === GENRE);
        if (genreAttribute) {
            return genreAttribute.values.map(({ value }) => value);
        }
        else {
            return [];
        }
    });
    return [...new Set(genres)];
}
function getCountGamesByGenre(games, element) {
    const visibleGames = games.filter(item => element.querySelector(`[data-sku="${item.sku}"]`));
    const genreCounts = visibleGames.reduce((counts, item) => {
        const genreAttribute = item.attributes.find(attr => attr.name.toLowerCase() === GENRE);
        if (genreAttribute) {
            const uniqueGenres = new Set();
            genreAttribute.values.forEach(value => {
                const genre = value.value.toLowerCase();
                if (!uniqueGenres.has(genre)) {
                    uniqueGenres.add(genre);
                    counts[genre] = (counts[genre] || 0) + 1;
                }
            });
        }
        return counts;
    }, {});
    return genreCounts;
}
export const GenreFilter = ({ element, selectedGenre, handleGenreChange, state, }) => {
    const [genres, setGenres] = useState([]);
    const [gamesCountByGenre, setGamesCountByGenre] = useState({});
    useEffect(() => {
        setGenres(extractGenres(state.storeState.units.items));
        setGamesCountByGenre(getCountGamesByGenre(state.storeState.units.items, element));
    }, []);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const onSelectGenre = (genre) => {
        handleGenreChange(genre);
        setIsOpen(false);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current &&
                event.target instanceof Node &&
                !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (_jsxs("div", { className: "filter-dropdown", ref: dropdownRef, children: [_jsx("label", { className: "filter-dropdown__label", children: 'BY GENRE' }), _jsx("div", { className: "filter-dropdown__header", onClick: toggleDropdown, role: "button", tabIndex: 0, "aria-expanded": isOpen, "aria-haspopup": "listbox", children: selectedGenre || 'All games' }), isOpen && (_jsxs("ul", { className: "filter-dropdown__list", children: [_jsx("li", { className: `filter-dropdown__item ${selectedGenre === '' ? 'filter-dropdown__item--active' : ''}`, onClick: () => {
                            onSelectGenre('');
                        }, role: "option", "aria-selected": selectedGenre === '', children: 'All games' }, "all"), genres.map((genre) => (_jsx("li", { className: `filter-dropdown__item ${selectedGenre === genre ? 'filter-dropdown__item--active' : ''}`, onClick: () => {
                            onSelectGenre(genre);
                        }, role: "option", "aria-selected": selectedGenre === genre, children: `${genre} - ${gamesCountByGenre[genre.toLowerCase()] || 0}` }, genre)))] }))] }));
};
